import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from '../authservice';

@Injectable()
export class Admin_Role implements CanActivate {

    constructor(public auth: AuthService) { }

    canActivate() {

        if (this.auth.isLoggedIn) {
            return (this.auth.role == 'Admin' || this.auth.role == 'Service Manager');
        } else {
            return false;
        }

    }
}